import { render, staticRenderFns } from "./DlgSendAllCeoMail.vue?vue&type=template&id=0506fa63&scoped=true"
import script from "./DlgSendAllCeoMail.vue?vue&type=script&lang=ts"
export * from "./DlgSendAllCeoMail.vue?vue&type=script&lang=ts"
import style0 from "./DlgSendAllCeoMail.vue?vue&type=style&index=0&id=0506fa63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506fa63",
  null
  
)

export default component.exports